import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";

import { IToast } from "@interfaces";
import { closeToast, selectToast, useAppSelector } from "@redux";
import { notification } from "antd";
import { useEffect } from "react";
import styled from "styled-components";

// type NotificationPlacement = NotificationArgsProps["placement"];

const ToastStyle = styled.div`
    .ant-notification-notice-message {
        margin-bottom: 0;
    }
    .ant-notification-notice-close {
        top: 11px;
    }
`;

const styleDefaultNoti = {
    borderRadius: "4px",
    padding: "6px 16px",
};

const styleError = {
    ...styleDefaultNoti,
    backgroundColor: "#fdeded",
};
const styleWarning = {
    ...styleDefaultNoti,
    backgroundColor: "#fff4e5",
};

const styleSuccess = {
    ...styleDefaultNoti,
    backgroundColor: "#edf7ed",
};

export const ComponentToast = () => {
    //page hooks
    const toast = useAppSelector(selectToast).toast;
    const dispatch = useDispatch();

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }

        dispatch(closeToast());
    };

    const capitallizeText = (text?: string) => {
        if (!text || text === "center") return "";
        return text.charAt(0).toUpperCase() + text.slice(1);
    };

    const openNotification = (t: IToast) => {
        const capitalized = capitallizeText(t.horizontal);
        const placement = t.vertical || capitalized ? t.vertical + capitalized : "top";

        const config = {
            duration: t.autoHideDuration,
            message: <ToastStyle>{t.message}</ToastStyle>,
            placement: placement as any,
            onClose: handleClose,
        };

        if (t.type === "success") {
            notification.success({ ...config, style: styleSuccess });
        } else if (t.type === "warning") {
            notification.warning({ ...config, style: styleWarning });
        } else if (t.type === "error") {
            notification.error({ ...config, style: styleError });
        } else {
            notification.open(config);
        }
    };

    useEffect(() => {
        if (toast.open) {
            openNotification(toast);
        }
    }, [toast]);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                limit={1}
            />
        </>
    );
};
